import React from "react";
import { CFormGroup, CSelect } from "@coreui/react";
import { withTranslation } from "react-i18next";

const SortBy = ({ setSortByHandle, t }: any) => {
    return (
        <CFormGroup className="showing-record">
            <CSelect className="select-record" name="records" id="records" onChange={(e: any) => setSortByHandle(e.target.value)}>
                <option value="createdAt">{t('AdminLayout.Latest created')}</option>
                <option value="lastLogin">{t('AdminLayout.Latest connection')}</option>
            </CSelect>
        </CFormGroup>
    );
};

export default (withTranslation)()(SortBy);
